if (!customElements.get("ld-blog-carousel")) {
  customElements.define(
    "ld-blog-carousel",
    class LdBlogCarousel extends HTMLElement {
      constructor() {
        super();
        this.isMobile = window.innerWidth <= 768;
      }

      initSwiperDesktop() {
        if (!this.isMobile) {
          return;
        }
        const wrapper = this.querySelector(".swiper");
        const slidesSize = wrapper.querySelectorAll(".swiper-slide").length;
        if (slidesSize <= 1) {
          return;
        }
        const swiper = new Swiper(wrapper, {
          slidesPerView: 1.1,
          threshold: 30,
          spaceBetween: 16,
          centeredSlides: true,
          // simulateTouch: this.isMobile,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: wrapper.querySelector(".swiper-pagination"),
            clickable: true,
          },
        });
      }

      connectedCallback() {
        this.initSwiperDesktop();
      }
    }
  );
}
